import React, { useState } from "react";
import IndexCycles from "./IndexCycles";
import IndexMembers from "./IndexMembers";
import { closeAllTooltip } from "../../../utils/closeAllTooltip";

export default function Index({ className, buttonName, teamId }) {
  const [type, setTypeWork] = useState("cycles");
  const [cycle, setCycle] = useState();

  const showMembers = (cycle) => {
    setCycle(cycle);
    closeAllTooltip();
    setTypeWork("members");
  };

  const showCycles = () => {
    closeAllTooltip();
    setTypeWork("cycles");
  };

  return (
    <>
      {type == "cycles" && (
        <IndexCycles
          className={className}
          buttonName={buttonName}
          teamId={teamId}
          showMembers={showMembers}
        />
      )}
      {type == "members" && (
        <IndexMembers
          className={className}
          cycle={cycle}
          teamId={teamId}
          showCycles={showCycles}
        />
      )}
    </>
  );
}
